import { getFormattingLocale } from './getFormattingLocales';

export const getDecimalSeparatorForLocale = (
  locale: string = getFormattingLocale()
): string | undefined => {
  return new Intl.NumberFormat(locale)
    .formatToParts(1.1)
    .find((part) => part.type === 'decimal')?.value;
};

export const getThousandsSeparatorForLocale = (
  disableThousandsSeparator: boolean,
  locale: string = getFormattingLocale()
): string | undefined => {
  if (disableThousandsSeparator) {
    return '';
  }

  return new Intl.NumberFormat(locale)
    .formatToParts(1000)
    .find((part) => part.type === 'group')?.value;
};
